import { useContext, useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { ContextApp } from '../../context';
import HeaderContainer from '../header';
import Footer from '../footer';
import {
    HomePageContainer,
    DescPageContainer,
    PremieresPageContainer,
    FavoritesPageContainer,
    TermsPage,
    ConfidentialityPage,
    FaqPage,
    ContactsPage,
    NotFoundPage,
} from '../pages';

const App = () => {
    return (
        <div className='app'>
            <HeaderContainer />
            <main className='main-content' role='main'>
                <div className='container'>
                    <Switch>
                        <Route path='/' component={HomePageContainer} exact />
                        <Route path='/desc/:id' component={DescPageContainer} />
                        <Route path='/premieres' component={PremieresPageContainer} />
                        <Route path='/favorites' component={FavoritesPageContainer} />
                        <Route path='/terms' component={TermsPage} />
                        <Route path='/confidentiality' component={ConfidentialityPage} />
                        <Route path='/faq' component={FaqPage} />
                        <Route path='/contacts' component={ContactsPage} />
                        <Route component={NotFoundPage} />
                    </Switch>
                </div>
            </main>
            <Footer />
        </div>
      );
};

const AppContainer = () => {
    const { state: { queryString: queryStringContext, start } } = useContext(ContextApp);
    const location = useLocation();
    const { push } = useHistory();
    const query = queryString.parse(location.search,{arrayFormat: 'comma'});
    const type = ((query.type) ? `type=${query.type}` : '');

    useEffect(() => {
        if (!start) {
            push(location.pathname + '?' + type + (Object.keys(query).length === 1 || query.type === undefined ? '' : '&') + queryString.stringify(queryStringContext, {arrayFormat: 'comma'}));
        }

        // eslint-disable-next-line
    }, [queryStringContext]);

    return <App />;
};

export default AppContainer;
